import React, { useState, useEffect, useCallback } from "react";
import { StyleSheet } from "react-native";
import {
  Box,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { useSelector } from "react-redux";
import { Picker } from "@react-native-picker/picker";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { translateText } from "../../translations/translationService";
import "../../style/style.css";
import {
  DEPARTAMENTS,
  typeConnect,
  backgroundColor2,
} from "../../constants/Constants";
import { SCREEN_IDS } from "../FullComponent.js";
import { getFullUsuarios } from "../../services/ConnectDataBase";
import {
  getFullInfoDailyReport,
  fetchCalendarioLaboral,
} from "../../services/ConnectDataBase";
import { formatDateTime } from "../../services/Functions";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { es } from "date-fns/locale";
import { STATUS_COLORS, BACKGROUND_COLORS, BORDER_COLORS, QUERY_DETALLE_TIEMPOS_COLORS } from "../../style/colors.js";
registerLocale("es", es);

const QueryDetalleTiempos = () => {
  // Estados para filtros
  const [fecha, setFecha] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [departamento, setDepartamento] = useState("");
  const [mo, setMo] = useState("");
  const [po, setPo] = useState("");
  const lang = useSelector((state) => state.lang.value);
  const [referencia, setReferencia] = useState("");

  // Estados para datos y operadores
  const [dataNoGroup, setDataNoGroup] = useState([]);
  const [listOperator, setListOperator] = useState([]);
  const calendarioLaboral = useSelector((state) => state.calendario);

  // Estados para manejo de consulta y carga
  const [consultaEnviada, setConsultaEnviada] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [newTableData, setNewTableData] = useState([]);
  const currentScreenId = SCREEN_IDS.INFO_DIARIO;
  const [operariosFiltrados, setOperariosFiltrados] = useState([]);
  const [orden, setOrden] = useState({ campo: "team", direccion: "asc" });
  const [selectedOperario, setSelectedOperario] = useState("");
  const [piezasPorOperario, setPiezasPorOperario] = useState([]);

  const userQuery = "userQuery";

  // Manejo de fechas
  const onChangeDate = (date) => {
    setFecha(date);
  };

  const onChangeDateFin = (date) => {
    const maxRange = 31;
    const startDate = new Date(fecha);
    const endDate = new Date(date);
    const diffTime = Math.abs(endDate - startDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays > maxRange) {
      const adjustedEndDate = new Date(startDate);
      adjustedEndDate.setDate(adjustedEndDate.getDate() + maxRange);
      setFechaFin(adjustedEndDate);
    } else {
      setFechaFin(date);
    }
  };

  // Selección de operario
  const seleccionarUsuario = (usuario) => {
    setSelectedOperario(usuario);
  };

  const formatMinutesToHoursMinutes = (minutes) => {
    const totalMinutes = Math.round(minutes);
    const hours = Math.floor(totalMinutes / 60);
    const mins = totalMinutes % 60;
    return `${hours}h ${mins}m`;
  };

  const convertirTiempoAMinutos = (duracion) => {
    if (!duracion) {
      return 0;
    }

    // Si duracion es un objeto con un campo 'date'
    if (typeof duracion === "object" && duracion.date) {
      duracion = duracion.date;
    }

    // Extraer la parte de tiempo (HH:MM:SS) de la cadena
    const timeMatch = duracion.match(/\d{2}:\d{2}:\d{2}/);
    if (timeMatch) {
      const [hours, minutes, seconds] = timeMatch[0].split(":").map(Number);
      const totalMinutes = hours * 60 + minutes + seconds / 60;
      return totalMinutes;
    }

    console.warn("Formato de duración no reconocido:", duracion);
    return 0;
  };

  const calcularHorasLectivas = (fechaInicio, fechaFin, calendarioLaboral) => {
    if (!fechaInicio || !fechaFin) return 0;

    const minutosPorDia = 6.8 * 60;

    let diasHabiles = 0;

    for (
      let fecha = new Date(fechaInicio);
      fecha <= fechaFin;
      fecha.setDate(fecha.getDate() + 1)
    ) {
      const esFinDeSemana = fecha.getDay() === 0 || fecha.getDay() === 6;
      const esFestivo = calendarioLaboral.some((festivo) => {
        const fechaFestivo = new Date(
          festivo.FECHA.split("-").reverse().join("-")
        );
        return (
          fechaFestivo.getFullYear() === fecha.getFullYear() &&
          fechaFestivo.getMonth() === fecha.getMonth() &&
          fechaFestivo.getDate() === fecha.getDate()
        );
      });

      if (!esFestivo) {
        if (!esFinDeSemana) {
          diasHabiles++;
        }
      }
    }

    return diasHabiles * minutosPorDia;
  };

  const horasLectivas = calcularHorasLectivas(
    new Date(fecha),
    new Date(fechaFin),
    calendarioLaboral
  );

  // Carga inicial de operadores
  useEffect(() => {
    operationLoad();
    fetchCalendarioLaboral();
  }, []);

  // Filtrado de operarios según departamento
  useEffect(() => {
    if (departamento) {
      const operariosFiltrados = listOperator.filter(
        (operario) => operario.team === departamento
      );
      setOperariosFiltrados(operariosFiltrados);
    } else {
      setOperariosFiltrados([]);
    }
  }, [departamento, listOperator]);

  // Ordenamiento de datos
  const ordenarPor = (campo) => {
    setOrden((prevOrden) => ({
      campo,
      direccion:
        prevOrden.campo === campo && prevOrden.direccion === "asc"
          ? "desc"
          : "asc",
    }));
  };

  useEffect(() => {
    const newDataNoGroup = [...dataNoGroup];
    newDataNoGroup.sort((a, b) => {
      if (a[orden.campo] < b[orden.campo]) {
        return orden.direccion === "asc" ? -1 : 1;
      }
      if (a[orden.campo] > b[orden.campo]) {
        return orden.direccion === "asc" ? 1 : -1;
      }
      return 0;
    });
    setDataNoGroup(newDataNoGroup);
  }, [orden]);

  useEffect(() => {
    if (departamento) {
      if (selectedOperario) {
        setNewTableData([{ nombre: selectedOperario }]);
      } else {
        setNewTableData(
          operariosFiltrados.map((operario) => ({
            nombre: operario.name,
          }))
        );
      }
    } else {
      setNewTableData([]);
    }
  }, [departamento, selectedOperario, operariosFiltrados]);

  useEffect(() => {
    if (dataNoGroup && dataNoGroup.length > 0) {
      const operatorDurations = {};
      const operatorTheoretical = {};
      const operatorPieces = {};
      const processedMOs = {};

      dataNoGroup.forEach((item) => {
        const operatorName = item.usuario;
        const mo = item.mo;
        const duration = convertirTiempoAMinutos(item.duracion);
        const numeropiedras = parseFloat(item.numeropiedras) || 0;
        const cantidad = parseFloat(item.cantidad_proceso) || 0;
        const theoretical = numeropiedras * cantidad || 0;

        if (operatorDurations[operatorName]) {
          operatorDurations[operatorName] += duration;
        } else {
          operatorDurations[operatorName] = duration;
        }

        // Inicializamos el Set para el operario si no existe
        if (!processedMOs[operatorName]) {
          processedMOs[operatorName] = new Set();
        }

        // Solo sumamos el teórico y las piezas si esa MO no se ha procesado aún para este operario
        if (!processedMOs[operatorName].has(mo)) {
          processedMOs[operatorName].add(mo);
          if (operatorTheoretical[operatorName]) {
            operatorTheoretical[operatorName] += theoretical;
          } else {
            operatorTheoretical[operatorName] = theoretical;
          }

          // Sumar cantidad de piezas (sin duplicar MOs)
          if (operatorPieces[operatorName]) {
            operatorPieces[operatorName] += cantidad;
          } else {
            operatorPieces[operatorName] = cantidad;
          }
        }
      });

      const newData = Object.keys(operatorDurations).map((operatorName) => ({
        nombre: operatorName,
        duracion: operatorDurations[operatorName],
        teorico: operatorTheoretical[operatorName] || 0,
      }));

      const piezasData = Object.keys(operatorPieces).map((operatorName) => ({
        nombre: operatorName,
        piezas: operatorPieces[operatorName] || 0,
      }));

      setNewTableData(newData);
      setPiezasPorOperario(piezasData);
    } else {
      setNewTableData([]);
      setPiezasPorOperario([]);
    }
  }, [dataNoGroup]);

  const operationLoad = async () => {
    setIsLoading(true);
    try {
      const listaOperarios = await getFullUsuarios(
        currentScreenId,
        typeConnect[0],
        userQuery
      );
      if (listaOperarios) {
        setIsLoading(false);
        setListOperator(listaOperarios);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const handleTouchablePress = useCallback(async () => {
    try {
      setDataNoGroup(""); // Resetea la tabla
      setConsultaEnviada(true);
      setIsLoading(true);

      const formattedFecha = fecha
        ? `${fecha.getFullYear()}-${("0" + (fecha.getMonth() + 1)).slice(
            -2
          )}-${("0" + fecha.getDate()).slice(-2)}`
        : "";
      const formattedFechaFin = fechaFin
        ? `${fechaFin.getFullYear()}-${("0" + (fechaFin.getMonth() + 1)).slice(
            -2
          )}-${("0" + fechaFin.getDate()).slice(-2)}`
        : "";

      const fullMo = await getFullInfoDailyReport(
        currentScreenId,
        typeConnect[0],
        formattedFecha,
        formattedFechaFin,
        departamento,
        mo,
        po,
        referencia,
        selectedOperario
      );

      // Ordenar por fecha_ini.date
      fullMo.sort((a, b) => {
        const dateA = new Date(a.fecha_ini.date);
        const dateB = new Date(b.fecha_ini.date);
        return dateA - dateB; // Orden ascendente
      });

      setDataNoGroup(fullMo); // Actualiza la tabla con los datos ordenados
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  }, [fecha, fechaFin, departamento, mo, po, referencia, selectedOperario]);

  const abreviarNombre = (nombreCompleto) => {
    const partes = nombreCompleto.split(",");
    if (partes.length > 1) {
      const apellidos = partes[0].trim();
      const palabrasApellidos = apellidos.split(" ");
      const primerApellido =
        palabrasApellidos[0].charAt(0).toUpperCase() +
        palabrasApellidos[0].slice(1).toLowerCase();
      return primerApellido;
    }
    return nombreCompleto;
  };

  const abreviarFecha = (fechaCompleta) => {
    if (!fechaCompleta) {
      return "";
    }

    if (typeof fechaCompleta === "object" && fechaCompleta.date) {
      fechaCompleta = fechaCompleta.date;
    }

    if (typeof fechaCompleta === "string") {
      const [fecha, hora] = fechaCompleta.split(" ");
      if (!fecha || !hora) {
        return "";
      }
      const [año, mes, día] = fecha.split("-");
      const [horas, minutos] = hora.split(":");
      return `${parseInt(día)}/${parseInt(mes)} ${horas}:${minutos}`;
    }

    console.warn("Formato de fecha no reconocido:", fechaCompleta);
    return "";
  };

  const formatDuration = (duracion) => {
    if (!duracion) {
      return "";
    }

    if (typeof duracion === "object" && duracion.date) {
      duracion = duracion.date;
    }

    if (typeof duracion === "string") {
      const timeMatch = duracion.match(/\d{2}:\d{2}:\d{2}/);
      if (timeMatch) {
        const [hours, minutes, seconds] = timeMatch[0].split(":").map(Number);
        const totalMinutes = hours * 60 + minutes + seconds / 60;
        return totalMinutes.toFixed(2);
      }
      return duracion;
    }

    console.warn("Formato de duración no reconocido:", duracion);
    return "";
  };

  const exportToExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Reporte");

    // Definir columnas
    worksheet.columns = headers.map((header) => ({
      header: header.label,
      key: header.campo,
      width: 15,
    }));

    try {
      // Agregar datos
      dataNoGroup.forEach((item) => {
        const rowData = getRowData(item);
        worksheet.addRow(rowData);
      });

      // Formatear columnas de fecha
      ["fecha_ini", "fecha_fin"].forEach((col) => {
        worksheet.getColumn(col).numFmt = "dd/mm/yyyy";
      });

      // Formatear columnas numéricas
      const numericColumns = [
        "duracion",
        "t_teorico",
        "teorico_uni",
        "peso",
        "piedras_engastar",
        "cantidad_proceso",
      ];
      numericColumns.forEach((col) => {
        worksheet.getColumn(col).numFmt = "0.00";
      });

      // Aplicar filtros al encabezado
      worksheet.autoFilter = {
        from: "A1",
        to: {
          row: 1,
          column: headers.length,
        },
      };

      // Estilizar el encabezado
      worksheet.getRow(1).font = { bold: true };

      // Generar y descargar el archivo Excel
      workbook.xlsx
        .writeBuffer()
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Reporte.xlsx");
        })
        .catch((error) => {
          console.error("Error al generar el Excel:", error);
        });
    } catch (error) {
      console.error("Error al crear el Excel:", error);
    }
  };

  const getRowData = (item) => {
    const rowData = {};
    headers.forEach((header) => {
      let value;
      switch (header.campo) {
        case "po":
          value = item.po || "";
          break;
        case "mo":
          value = item.mo || "";
          break;
        case "referencia":
          value = item.referencia || "";
          break;
        case "usuario":
          value = abreviarNombre(item.usuario) || "";
          break;
        case "team":
          value = item.team || "";
          break;
        case "fecha_ini":
        case "fecha_fin":
          let dateValue = item[header.campo];

          if (dateValue && dateValue.date) {
            dateValue = new Date(dateValue.date);
          } else if (typeof dateValue === "string") {
            dateValue = new Date(dateValue);
          } else {
            dateValue = null;
          }

          if (dateValue && !isNaN(dateValue.getTime())) {
            // Ajustar fecha manualmente sin considerar la zona horaria UTC
            value = new Date(
              dateValue.getFullYear(),
              dateValue.getMonth(),
              dateValue.getDate(),
              12,
              0,
              0
            );
          } else {
            value = null;
          }
          break;
        case "duracion":
          const duracion = convertirTiempoAMinutos(item.duracion);
          value = !isNaN(duracion) ? duracion : null;
          break;
        case "t_teorico":
          const numeropiedras = parseFloat(item.numeropiedras);
          const cantidad_proceso = parseFloat(item.cantidad_proceso);
          const tTeorico =
            !isNaN(numeropiedras) && !isNaN(cantidad_proceso)
              ? numeropiedras * cantidad_proceso
              : null;
          value = tTeorico;
          break;
        case "teorico_uni":
          const numeropiedras2 = parseFloat(item.numeropiedras);
          value = !isNaN(numeropiedras2) ? numeropiedras2 : null;
          break;
        case "peso":
          const peso = parseFloat(item.peso);
          value = !isNaN(peso) ? peso : null;
          break;
        case "piedras_engastar":
          const piedrasEngastar = parseFloat(item.piedras_engastar);
          value = !isNaN(piedrasEngastar) ? piedrasEngastar : null;
          break;
        case "cantidad_proceso":
          const cantidadProceso = parseFloat(item.cantidad_proceso);
          value = !isNaN(cantidadProceso) ? cantidadProceso : null;
          break;
        case "Tipo":
          value = item.tipo || "";
          break;
        default:
          value = item[header.campo] || "";
      }
      rowData[header.campo] = value;
    });
    return rowData;
  };

  const headers = [
    { label: translateText("PO", lang), campo: "po" },
    { label: translateText("MO", lang), campo: "mo" },
    { label: translateText("Referencia", lang), campo: "referencia" },
    { label: translateText("Usuario", lang), campo: "usuario" },
    { label: translateText("Team", lang), campo: "team" },
    { label: translateText("F. inicio", lang), campo: "fecha_ini" },
    { label: translateText("F. final", lang), campo: "fecha_fin" },
    { label: translateText("Tiempo", lang), campo: "duracion" },
    { label: translateText("T. teórico", lang), campo: "t_teorico" },
    { label: translateText("Teórico uni", lang), campo: "teorico_uni" },
    { label: translateText("Peso", lang), campo: "peso" },
    { label: translateText("Nº Piedras", lang), campo: "piedras_engastar" },
    { label: translateText("Cantidad", lang), campo: "cantidad_proceso" },
    { label: translateText("Tipo", lang), campo: "tipo" },
  ];

  const dataFields = [
    (item) => item.po,
    (item) => item.mo,
    (item) => item.referencia,
    (item) => abreviarNombre(item.usuario),
    (item) => item.team,
    (item) => abreviarFecha(item.fecha_ini),
    (item) => abreviarFecha(item.fecha_fin),
    (item) => formatDuration(item.duracion),
    (item) => {
      const numeropiedras = parseFloat(item.numeropiedras);
      const cantidad_proceso = parseFloat(item.cantidad_proceso);
      if (!isNaN(numeropiedras) && !isNaN(cantidad_proceso)) {
        return (numeropiedras * cantidad_proceso).toFixed(1);
      } else {
        return "0";
      }
    }, // Placeholder for T. teórico
    (item) => {
      const numeropiedras = parseFloat(item.numeropiedras);
      return !isNaN(numeropiedras) ? numeropiedras.toFixed(1) : "";
    },
    // Placeholder for Teórico uni
    (item) =>
      !isNaN(parseFloat(item.peso)) ? parseFloat(item.peso).toFixed(2) : "",
    (item) =>
      !isNaN(parseFloat(item.piedras_engastar))
        ? parseFloat(item.piedras_engastar).toFixed(0)
        : "",
    (item) =>
      !isNaN(parseFloat(item.cantidad_proceso))
        ? parseFloat(item.cantidad_proceso).toFixed(1)
        : " ",
    (item) => item.tipo,
  
  ];

  return (
    <Box sx={{ padding: 2, backgroundColor: QUERY_DETALLE_TIEMPOS_COLORS.BACKGROUND_HEADER }}>
      {/* Filtros Mejorados */}
      <Box
        sx={{
          backgroundColor: QUERY_DETALLE_TIEMPOS_COLORS.BACKGROUND_CARD,
          borderRadius: 2,
          padding: 2,
          mb: 2,
          boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
        }}>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1.5,
            alignItems: "flex-end",
            // overflowX: "auto",
            pb: 1,
          }}>
          {/* Fecha inicial */}
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: backgroundColor2,
                  fontSize: "14px",
                  fontWeight: 600,
                }}>
                📅 {translateText("Fecha inicial", lang)}:
              </Box>
            </Box>
            <DatePicker
              selected={fecha}
              onChange={onChangeDate}
              dateFormat='dd/MM/yyyy'
              className='custom-datepicker-compact'
              placeholderText=''
              locale='es'
              portalId='root-portal'
              style={{
                width: "100%",
                height: "36px",
                fontSize: "14px",
                borderRadius: "6px",
              }}
            />
          </Box>

          {/* Fecha fin */}
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: backgroundColor2,
                  fontSize: "14px",
                  fontWeight: 600,
                }}>
                📅 {translateText("Fecha fin", lang)}:
              </Box>
            </Box>
            <DatePicker
              selected={fechaFin}
              onChange={onChangeDateFin}
              dateFormat='dd/MM/yyyy'
              className='custom-datepicker-compact'
              placeholderText='(max 31 days)'
              locale='es'
              portalId='root-portal'
              style={{
                width: "100%",
                height: "36px",
                fontSize: "14px",
                borderRadius: "6px",
              }}
            />
          </Box>

          {/* Departamento */}
          <Box sx={{ minWidth: "180px", flex: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: backgroundColor2,
                  fontSize: "14px",
                  fontWeight: 600,
                }}>
                🏢 {translateText("Departamento", lang)}:
              </Box>
            </Box>
            <Select
              value={departamento}
              onChange={(e) => setDepartamento(e.target.value)}
              displayEmpty
              fullWidth
              size='small'
              sx={{
                height: "36px",
                fontSize: "14px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "6px",
                  backgroundColor: QUERY_DETALLE_TIEMPOS_COLORS.BACKGROUND_ROW,
                },
              }}>
              <MenuItem value=''>
                <em>{translateText("Ninguno", lang)}</em>
              </MenuItem>
              {Object.values(DEPARTAMENTS)
                .filter((dep) => dep !== "CCSS")
                .map((dep) => (
                  <MenuItem key={dep} value={dep}>
                    {translateText(dep, lang)}
                  </MenuItem>
                ))}
            </Select>
          </Box>

          {/* MO */}
          <Box sx={{ minWidth: "100px", flex: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: backgroundColor2,
                  fontSize: "14px",
                  fontWeight: 600,
                }}>
                📄 {translateText("MO", lang)}:
              </Box>
            </Box>
            <TextField
              value={mo}
              onChange={(e) => setMo(e.target.value)}
              type='text'
              variant='outlined'
              size='small'
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: "36px",
                  fontSize: "14px",
                  borderRadius: "6px",
                  backgroundColor: QUERY_DETALLE_TIEMPOS_COLORS.BACKGROUND_ROW,
                },
              }}
            />
          </Box>

          {/* PO */}
          <Box sx={{ minWidth: "100px", flex: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: backgroundColor2,
                  fontSize: "14px",
                  fontWeight: 600,
                }}>
                📋 {translateText("PO", lang)}:
              </Box>
            </Box>
            <TextField
              value={po}
              onChange={(e) => setPo(e.target.value)}
              type='number'
              variant='outlined'
              size='small'
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: "36px",
                  fontSize: "14px",
                  borderRadius: "6px",
                  backgroundColor: QUERY_DETALLE_TIEMPOS_COLORS.BACKGROUND_ROW,
                },
              }}
            />
          </Box>

          {/* Referencia */}
          <Box sx={{ minWidth: "140px", flex: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: backgroundColor2,
                  fontSize: "14px",
                  fontWeight: 600,
                }}>
                🏷️ {translateText("Referencia", lang)}:
              </Box>
            </Box>
            <TextField
              value={referencia}
              onChange={(e) => setReferencia(e.target.value)}
              variant='outlined'
              size='small'
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: "36px",
                  fontSize: "14px",
                  borderRadius: "6px",
                  backgroundColor: BACKGROUND_COLORS.TERTIARY,
                },
              }}
            />
          </Box>

          {/* Operarios */}
          <Box sx={{ minWidth: "180px", flex: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: backgroundColor2,
                  fontSize: "14px",
                  fontWeight: 600,
                }}>
                👥 {translateText("Operarios", lang)}:
              </Box>
            </Box>
            <Select
              value={selectedOperario || ""}
              onChange={(e) => seleccionarUsuario(e.target.value)}
              displayEmpty
              fullWidth
              size='small'
              sx={{
                height: "36px",
                fontSize: "14px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "6px",
                  backgroundColor: BACKGROUND_COLORS.TERTIARY,
                },
              }}>
              <MenuItem value=''>
                <em>{translateText("Seleccione un operario", lang)}</em>
              </MenuItem>
              {operariosFiltrados.map((operario, index) => (
                <MenuItem key={index} value={operario.name}>
                  {operario.name}
                </MenuItem>
              ))}
            </Select>
          </Box>

          {/* Botones */}
          <Box
            sx={{
              display: "flex",
              gap: 1,
              ml: 2,
              flex: 1,
            }}>
            <Button
              variant='contained'
              onClick={handleTouchablePress}
              disabled={isLoading}
              sx={{
                minWidth: "90px",
                height: "36px",
                backgroundColor: backgroundColor2,
                color: "white",
                borderRadius: "6px",
                fontSize: "12px",
                fontWeight: "bold",
                textTransform: "uppercase",
                boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
                "&:hover": {
                  backgroundColor: QUERY_DETALLE_TIEMPOS_COLORS.BACKGROUND_BUTTON_PRIMARY,
                  boxShadow: "0px 4px 8px rgba(0,0,0,0.3)",
                },
                "&:disabled": {
                  backgroundColor: QUERY_DETALLE_TIEMPOS_COLORS.BACKGROUND_BUTTON_SECONDARY,
                },
              }}>
              {isLoading ? "..." : translateText("ENVIAR", lang)}
            </Button>

            <Button
              variant='contained'
              onClick={exportToExcel}
              sx={{
                minWidth: "90px",
                height: "36px",
                backgroundColor: STATUS_COLORS.SUCCESS,
                color: "white",
                borderRadius: "6px",
                fontSize: "12px",
                fontWeight: "bold",
                textTransform: "uppercase",
                boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
                "&:hover": {
                  backgroundColor: QUERY_DETALLE_TIEMPOS_COLORS.BACKGROUND_SUCCESS,
                  boxShadow: "0px 4px 8px rgba(0,0,0,0.3)",
                },
              }}>
              EXCEL
            </Button>
          </Box>
        </Box>
      </Box>

      {/* CSS adicional para DatePickers compactos */}
      <style jsx global>{`
        .custom-datepicker-compact .react-datepicker__input-container input {
          height: 36px !important;
          font-size: 14px !important;
          border-radius: 6px !important;
          background-color: ${BACKGROUND_COLORS.TERTIARY} !important;
          border: 1px solid ${BORDER_COLORS.LIGHT} !important;
          padding: 8px 12px !important;
        }
      `}</style>


      {/* Tablas de resumen lado a lado */}
      {departamento !== "" && (newTableData.length > 0 || piezasPorOperario.length > 0) && (
        <Box sx={{ mb: 2, display: "flex", gap: 2, flexWrap: "wrap" }}>
          {/* Tabla de horas trabajadas */}
          {newTableData.length > 0 && (
            <Box sx={{ flex: 1, minWidth: "400px" }}>
              <TableContainer
                component={Paper}
                sx={{
                  borderRadius: 2,
                  boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
                  overflow: "auto",
                }}>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align='center'
                        sx={{
                          backgroundColor: backgroundColor2,
                          color: "white",
                          fontWeight: "bold",
                          py: 1,
                        }}>
                        <Typography variant='subtitle2' sx={{ fontWeight: "bold", fontSize: "12px" }}>
                          {translateText("Operario", lang)}
                        </Typography>
                      </TableCell>

                      <TableCell
                        align='center'
                        sx={{
                          backgroundColor: backgroundColor2,
                          color: "white",
                          fontWeight: "bold",
                          py: 1,
                        }}>
                        <Typography variant='subtitle2' sx={{ fontWeight: "bold", fontSize: "12px" }}>
                          {translateText("Horas Trabajadas", lang)}
                        </Typography>
                      </TableCell>

                      <TableCell
                        align='center'
                        sx={{
                          backgroundColor: backgroundColor2,
                          color: "white",
                          fontWeight: "bold",
                          py: 1,
                        }}>
                        <Typography variant='subtitle2' sx={{ fontWeight: "bold", fontSize: "12px" }}>
                          {translateText("Horas Teóricas", lang)}
                        </Typography>
                      </TableCell>

                      <TableCell
                        align='center'
                        sx={{
                          backgroundColor: backgroundColor2,
                          color: "white",
                          fontWeight: "bold",
                          py: 1,
                        }}>
                        <Typography variant='subtitle2' sx={{ fontWeight: "bold", fontSize: "12px" }}>
                          {translateText("Horas Laborales", lang)}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {newTableData.map((item, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:nth-of-type(odd)": {
                            backgroundColor: QUERY_DETALLE_TIEMPOS_COLORS.BACKGROUND_ROW,
                          },
                          "&:hover": {
                            backgroundColor: QUERY_DETALLE_TIEMPOS_COLORS.BACKGROUND_ROW_ALTERNATE,
                          },
                        }}>
                        <TableCell
                          align='center'
                          sx={{
                            fontWeight: "500",
                            color: QUERY_DETALLE_TIEMPOS_COLORS.TEXT_PRIMARY,
                            py: 0.8,
                            fontSize: "12px",
                          }}>
                          {item.nombre}
                        </TableCell>

                        <TableCell
                          align='center'
                          sx={{
                            color: QUERY_DETALLE_TIEMPOS_COLORS.TEXT_SECONDARY,
                            py: 0.8,
                            fontSize: "12px",
                          }}>
                          {formatMinutesToHoursMinutes(item.duracion)}
                        </TableCell>

                        <TableCell
                          align='center'
                          sx={{
                            color: QUERY_DETALLE_TIEMPOS_COLORS.TEXT_SECONDARY,
                            py: 0.8,
                            fontSize: "12px",
                          }}>
                          {formatMinutesToHoursMinutes(item.teorico)}
                        </TableCell>

                        <TableCell
                          align='center'
                          sx={{
                            color: QUERY_DETALLE_TIEMPOS_COLORS.TEXT_SECONDARY,
                            py: 0.8,
                            fontSize: "12px",
                          }}>
                          {formatMinutesToHoursMinutes(horasLectivas)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}

          {/* Tabla de piezas por operario */}
          {piezasPorOperario.length > 0 && (
            <Box sx={{ flex: 1, minWidth: "300px" }}>
              <TableContainer
                component={Paper}
                sx={{
                  borderRadius: 2,
                  boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
                  overflow: "auto",
                }}>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align='center'
                        sx={{
                          backgroundColor: backgroundColor2,
                          color: "white",
                          fontWeight: "bold",
                          py: 1,
                        }}>
                        <Typography variant='subtitle2' sx={{ fontWeight: "bold", fontSize: "12px" }}>
                          {translateText("Operario", lang)}
                        </Typography>
                      </TableCell>

                      <TableCell
                        align='center'
                        sx={{
                          backgroundColor: backgroundColor2,
                          color: "white",
                          fontWeight: "bold",
                          py: 1,
                        }}>
                        <Typography variant='subtitle2' sx={{ fontWeight: "bold", fontSize: "12px" }}>
                          {translateText("Total Piezas", lang)}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {piezasPorOperario.map((item, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:nth-of-type(odd)": {
                            backgroundColor: QUERY_DETALLE_TIEMPOS_COLORS.BACKGROUND_ROW,
                          },
                          "&:hover": {
                            backgroundColor: QUERY_DETALLE_TIEMPOS_COLORS.BACKGROUND_ROW_ALTERNATE,
                          },
                        }}>
                        <TableCell
                          align='center'
                          sx={{
                            fontWeight: "500",
                            color: QUERY_DETALLE_TIEMPOS_COLORS.TEXT_PRIMARY,
                            py: 0.8,
                            fontSize: "12px",
                          }}>
                          {item.nombre}
                        </TableCell>

                        <TableCell
                          align='center'
                          sx={{
                            color: QUERY_DETALLE_TIEMPOS_COLORS.TEXT_SECONDARY,
                            fontWeight: "bold",
                            fontSize: "12px",
                            py: 0.8,
                          }}>
                          {item.piezas.toFixed(1)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
        </Box>
      )}
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: "60vh",
          borderRadius: 2,
          boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
          overflow: "auto",
        }}>
        <Table stickyHeader size='small'>
          <TableHead>
            <TableRow>
              {headers.map((item, index) => (
                <TableCell
                  key={index}
                  align='center'
                  sx={{
                    backgroundColor: backgroundColor2,
                    color: "white",
                    py: 1.5,
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    borderRight:
                      index < headers.length - 1
                        ? "1px solid rgba(255,255,255,0.2)"
                        : "none",
                  }}>
                  <Button
                    onClick={() => ordenarPor(item.campo)}
                    sx={{
                      backgroundColor: "transparent",
                      color: "white",
                      textTransform: "none",
                      padding: "4px 8px",
                      minWidth: 0,
                      borderRadius: 1,
                      "&:hover": {
                        backgroundColor: "rgba(255,255,255,0.1)",
                      },
                    }}>
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      <Typography
                        variant='caption'
                        sx={{ fontWeight: "bold", fontSize: "12px" }}>
                        {item.label}
                      </Typography>
                      {orden.campo === item.campo && (
                        <Box sx={{ fontSize: "14px" }}>
                          {orden.direccion === "asc" ? "↑" : "↓"}
                        </Box>
                      )}
                    </Box>
                  </Button>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {consultaEnviada && isLoading ? (
              <TableRow>
                <TableCell
                  colSpan={headers.length}
                  align='center'
                  sx={{ py: 8 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 2,
                    }}>
                    <CircularProgress
                      size={40}
                      sx={{ color: backgroundColor2 }}
                    />
                    <Typography variant='body2' color='text.secondary'>
                      {translateText("Consultando datos...", lang)}
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : consultaEnviada && dataNoGroup.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={headers.length}
                  align='center'
                  sx={{ py: 8 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 2,
                    }}>
                    <Box sx={{ fontSize: "48px", opacity: 0.3 }}>🔍</Box>
                    <Typography variant='body1' color='text.secondary'>
                      {translateText("No se encontraron resultados", lang)}
                    </Typography>
                    <Typography variant='body2' color='text.disabled'>
                      {translateText(
                        "Intenta ajustar los filtros de búsqueda",
                        lang
                      )}
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : !consultaEnviada && dataNoGroup.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={headers.length}
                  align='center'
                  sx={{ py: 8 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 2,
                    }}>
                    <Box sx={{ fontSize: "48px", opacity: 0.3 }}>⏳</Box>
                    <Typography variant='body1' color='text.secondary'>
                      {translateText("Esperando consulta", lang)}
                    </Typography>
                    <Typography variant='body2' color='text.disabled'>
                      {translateText(
                        "Configure los filtros y presione 'Enviar'",
                        lang
                      )}
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              dataNoGroup.map((item, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:nth-of-type(odd)": {
                      backgroundColor: QUERY_DETALLE_TIEMPOS_COLORS.BACKGROUND_ROW,
                    },
                    "&:hover": {
                      backgroundColor: QUERY_DETALLE_TIEMPOS_COLORS.BACKGROUND_ROW_ALTERNATE,
                      transform: "scale(1.001)",
                      transition: "all 0.1s ease",
                    },
                  }}>
                  {dataFields.map((getData, idx) => (
                    <TableCell
                      key={idx}
                      align='center'
                      sx={{
                        py: 1,
                        px: 1.5,
                        color: QUERY_DETALLE_TIEMPOS_COLORS.TEXT_SECONDARY,
                        borderRight:
                          idx < dataFields.length - 1
                            ? `1px solid ${QUERY_DETALLE_TIEMPOS_COLORS.BORDER_LIGHT}`
                            : "none",
                      }}>
                      {/* Formateo especial para ciertos campos */}
                      {headers[idx]?.campo === "duracion" && getData(item) ? (
                        <Box
                          sx={{
                            backgroundColor: QUERY_DETALLE_TIEMPOS_COLORS.BACKGROUND_ROW_SELECTED,
                            borderRadius: 1,
                            padding: "2px 6px",
                            display: "inline-block",
                            // fontSize: "11px",
                            fontFamily: "monospace",
                          }}>
                          {getData(item)}
                        </Box>
                      ) : headers[idx]?.campo === "usuario" ? (
                        <Box
                          sx={{
                            color: backgroundColor2,
                            fontWeight: "600",
                            // fontSize: "12px",
                          }}>
                          {getData(item)}
                        </Box>
                      ) : (
                        getData(item)
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};


export default QueryDetalleTiempos;
